import type { AiBoxDraft, BoxListItem } from "../../../api/WarehouseApi";
import { normalizeTypeTags } from "../../../utils/typeTags";

function resolveParentIdFromDraft(
  parentId: string | null,
  parentHint: string | null,
  availableBoxes: BoxListItem[],
): string | null {
  if (parentId && availableBoxes.some((box) => box.id === parentId)) {
    return parentId;
  }

  const hint = (parentHint || "").trim().toLocaleLowerCase("ru-RU");
  if (!hint) {
    return null;
  }

  const match = availableBoxes.find((box) => {
    const name = box.name.trim().toLocaleLowerCase("ru-RU");
    const id = box.id.trim().toLocaleLowerCase("ru-RU");
    return name.includes(hint) || id.includes(hint);
  });

  return match ? match.id : null;
}

interface ApplyAiDraftInput {
  draft: AiBoxDraft;
  availableBoxes: BoxListItem[];
  currentTypeTags: string[];
  formatParentInputValue: (value: string) => string;
}

export interface AppliedAiBoxDraft {
  name?: string;
  description?: string;
  photo?: string;
  typeTags?: string[];
  parentId?: string;
}

export function applyAiBoxDraft(input: ApplyAiDraftInput): AppliedAiBoxDraft {
  const patch: AppliedAiBoxDraft = {};

  if (input.draft.name) {
    patch.name = input.draft.name;
  }

  if (input.draft.description) {
    patch.description = input.draft.description;
  }

  if (input.draft.photo) {
    patch.photo = input.draft.photo;
  }

  if (input.draft.typeTags.length > 0) {
    patch.typeTags = normalizeTypeTags([
      ...input.currentTypeTags,
      ...input.draft.typeTags,
    ]);
  }

  const parentIdFromDraft = resolveParentIdFromDraft(
    input.draft.parentId,
    input.draft.parentHint,
    input.availableBoxes,
  );
  if (parentIdFromDraft) {
    patch.parentId = input.formatParentInputValue(parentIdFromDraft);
  }

  return patch;
}
